import type { ResourceSpecifier } from './ast';

const environmentScopedResources = [
  'segment',
  'experiment',
  'holdout',
  'user',
  'destination',
  'flag',
  'feature',
  'aiconfig',
  'metric-data-source',
  'assignment-data-source',
  'attribute-data-source',
  'product-analytics-dashboard',
  'notification-subscription',
  'sdk-key',
  'environment-release-plan',
] as const satisfies Array<ResourceSpecifier['type']>;

export type EnvironmentScopedResource = Extract<
  ResourceSpecifier,
  { type: (typeof environmentScopedResources)[number] }
>;

export const isEnvironmentScopedResourceType = (resourceType: ResourceSpecifier['type']) =>
  (environmentScopedResources as readonly string[]).includes(resourceType);

export const isEnvironmentScopedResource = (resource: ResourceSpecifier): resource is EnvironmentScopedResource =>
  isEnvironmentScopedResourceType(resource.type);
